import React, { useContext } from "react";
import { FormContext } from "../../App";
import Label from "../Label/Label";
import style from "./Textarea.module.css";

interface TextareaProps {
  label: string;
  name: string;
  required?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, name, required }, ref) => {
    const { register } = useContext(FormContext);
    return (
      <div className={style.textareaContainer}>
        <Label text={label} required={required} />
        <textarea
          ref={ref}
          {...register(name, { required })}
          className={style.textareaElement}
        ></textarea>
      </div>
    );
  }
);

export default Textarea;
